import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "textSection" }
const _hoisted_2 = {
  key: 0,
  class: "imgSection"
}
const _hoisted_3 = ["src"]

import { computed,inject  } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FreeProposal',
  setup(__props) {

const displayWidth:any=inject(`displayWidth`)
const store:any=inject(`store`)

function sendTo(to: string | null) {
  store.dispatch(`scrollToAction`, to);
}
const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_BaseCard, {
      class: "card",
      styleProp: "white"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "header" }, "Let’s make things happen", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text" }, "Contact us today to learn more about how our digital marketing services can help your business grow and succeed online.", -1)),
          _createVNode(_component_BaseButton, {
            class: _normalizeClass([`button`,{buttonMobile:computedDisplayWidth.value}]),
            color: "black",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (sendTo(`contact`))),
            text: "Get your free proposal"
          }, null, 8, ["class"])
        ]),
        (!computedDisplayWidth.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: require(`../assets/proposal.png`),
                alt: "Magic"
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})